<template>
  <div>
    <div id="app">

          <div class="outline">
              <h2 class="primary pl-3">Register for Memories For Us!</h2>
              <h4 class="primary pl-3">Enter your information below with the invitation code you received.</h4>
                <v-card class="px-4">
                  <v-card-text>
                    <h4 class="red--text" v-if="regmessage">{{ regmessage }}</h4>
                    <v-form ref="registerForm" v-model="valid" lazy-validation>
                      <p class="red--text" >{{ errMsg }}</p>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="firstName"
                            tabindex="1"
                            :rules="[rules.required]"
                            label="First Name"
                            maxlength="50"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="lastName"
                            tabindex="2"
                            :rules="[rules.required]"
                            label="Last Name"
                            maxlength="50"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="displayName"
                            tabindex="3"
                            :rules="[rules.required]"
                            label="How you want your name to appear to others"
                            maxlength="100"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="email"
                            tabindex="4"
                            :rules="emailRules"
                            label="E-mail"
                            required
                            color="m4u_text"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            tabindex="5"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required]"
                            :type="show1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Password"
                            @click:append="show1 = !show1"
                                :toggle="true"
                              :strength-meter-only="true"
                          ></v-text-field> 
                          <span class="red--text" v-if="passwordStrength.score < 4 && password.length >0">Weak Password<br /> 
                          <span v-if="passwordStrength.feedback.suggestions.length > 0">{{passwordStrength.feedback.suggestions}} </span>
                          <span v-if="passwordStrength.feedback.suggestions.length === 0">Almost strong enough! </span>
                          </span> 
                          <span class="green--text" v-if="passwordStrength.score >= 4">Strong Password</span>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            block
                            v-model="verify"
                            tabindex="6"
                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[rules.required, passwordMatch]"
                            :type="show1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Confirm Password"
                            @click:append="show1 = !show1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                           type="number"
                            v-model="invitationCode"
                            tabindex="7"
                            label="Invitation Code"
                            hint="Must be a number"
                            maxlength="25"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                  <h4 class="red--text" v-if="regmessage">{{ regmessage }}</h4>
                   <p class="red--text" >{{ errMsg }}</p>
                        <v-col class="d-flex ml-auto" cols="12" sm="3" xsm="12">
                          <v-btn
                            tabindex="8"
                            x-large
                            block
                            color="secondary"
                            @click="validateReg"
                            >Register</v-btn
                          >
                        </v-col>
                      </v-row>

                    </v-form>

                  </v-card-text>
                </v-card>
          </div>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
 import Password from 'zxcvbn';

export default {
  components: { Password },
  computed: {
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    },
    user() {
      return this.$store.state.user;
    },
    passwordStrength(){
        return Password( this.password );
    }
  },

  mounted() {
    this.regmessage = "";

  },
  methods: {

    validateReg() {
      if (this.$refs.registerForm.validate()) {
        if (isNaN(this.invitationCode)){ 
          this.errMsg = "Invitation Code must be a number"
          return
        }
        if(this.passwordStrength.score < 4) {
          this.errMsg = "Password must be stronger"
          return
        }
        // submit form to server/API here...
        this.errMsg = "";
        this.registration();
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },

    async registration() {
      EventService.invitationRegistration(
        this.firstName,
        this.lastName,
        this.displayName,
        this.email,
        this.password,
        this.invitationCode
      ).then((dupcheck) => {
        if (dupcheck === "duplicate") {
          this.regmessage = "This email address is already registered";
          return;
        } 
        
        if (dupcheck === "invalid invitation") {
        this.regmessage = "This email address AND/OR Invitation Code are not valid.";
          return; }

        this.$router.push({ name: "RegistrationConfirmation" });
        
      });
    },
  },
  data: () => ({
    userInfo: [],
    valid: true,

    firstName: "",
    lastName: "",
    displayName: "",
    email: "",
    password: "",
    invitationCode: "",
    verify: "",
    regmessage: "",
    errMsg: "",
    show1: "",
    ps: "",
    profileSas: "",
    emailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    loggedin: false,

    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
    },
  }),
};
</script>

<style scoped>

.outline {
  margin: 3em;
}
</style>
